export interface PlayModelActionDefinition {
  code: string;
  description: string;
}

export interface PlayModelPositionDefinition {
  code: string;
  description: string;
}

export const PLAY_MODEL_LABEL = 'Modelo Juego';
export const PLAY_MODEL_DISPLAY_LIMIT = 12;

export const PLAY_MODEL_POSITION_DEFINITIONS: PlayModelPositionDefinition[] = [
  { code: 'I', description: 'Izquierda' },
  { code: 'C', description: 'Centro' },
  { code: 'D', description: 'Derecha' },
];

export const PLAY_MODEL_ACTION_DEFINITIONS: PlayModelActionDefinition[] = [
  { code: '1', description: 'Cruce B - E' },
  { code: '2a', description: 'Cruce B - A/C' },
  { code: '2b', description: 'Cruce corto' },
  { code: '3a', description: 'Cruce A/C - B' },
  { code: '3b', description: 'Cruce por delante' },
  { code: '4', description: 'Cruce largo (A - C o C-A)' },
  { code: '5a', description: 'Desdoblamiento A/C corto' },
  { code: '5b', description: 'Desdoblamiento A/C cruzado' },
  { code: '5c', description: 'Desdoblamiento B' },
  { code: '7a', description: 'Circulación D/F - E 1-2' },
  { code: '7b', description: 'Circulación D/F - E 2-3' },
  { code: '7c', description: 'Circulación D/F rusa' },
  { code: '7d', description: 'Circulación D/F por fuera' },
  { code: '7e', description: 'Vuelta al puesto D/F' },
  { code: '8a', description: 'Permuta alta' },
  { code: '8b', description: 'Hacer saltar a los 3s' },
  { code: '9', description: 'Permuta baja' },
  { code: '0a', description: '1x1' },
  { code: '0b', description: '2x2' },
  { code: '0c', description: '4 primeras líneas' },
  { code: '0d', description: '4 primeras líneas + desdoblamiento A/C' },
];

export const PLAY_MODEL_HELP_EXAMPLES = [
  '2aI1435-7dC1443-0bD1455',
  '1C9201-5bI9203-8aD9231',
  '3bD2343-0aC2354',
];

const PLAY_MODEL_POSITION_CODES = PLAY_MODEL_POSITION_DEFINITIONS.map(position => position.code).join('');
const PLAY_MODEL_ACTION_LOOKUP = new Set(PLAY_MODEL_ACTION_DEFINITIONS.map(action => action.code.toLowerCase()));
const PLAY_MODEL_SEGMENT_REGEX = new RegExp(
  `^([A-Za-z0-9]{1,2})([${PLAY_MODEL_POSITION_CODES}${PLAY_MODEL_POSITION_CODES.toLowerCase()}]?)(\\d{4})?$`
);

export const PLAY_MODEL_VALIDATION_REGEX = new RegExp(
  `^(?:[A-Za-z0-9]{1,2}[${PLAY_MODEL_POSITION_CODES}${PLAY_MODEL_POSITION_CODES.toLowerCase()}]?(?:\\d{4})?)(?:-[A-Za-z0-9]{1,2}[${PLAY_MODEL_POSITION_CODES}${PLAY_MODEL_POSITION_CODES.toLowerCase()}]?(?:\\d{4})?)*$`
);

export function normalizePlayModelInput(value: string | null | undefined): string {
  return (value || '')
    .replace(/\s*-\s*/g, '-')
    .replace(/\s+/g, '')
    .trim();
}

export function findUnknownPlayModelActions(value: string | null | undefined): string[] {
  const normalizedValue = normalizePlayModelInput(value);
  if (!normalizedValue) {
    return [];
  }

  const unknownActions = new Set<string>();
  normalizedValue.split('-').forEach(segment => {
    const match = segment.match(PLAY_MODEL_SEGMENT_REGEX);
    if (!match) {
      return;
    }

    const actionCode = match[1].toLowerCase();
    if (actionCode && !PLAY_MODEL_ACTION_LOOKUP.has(actionCode)) {
      unknownActions.add(match[1]);
    }
  });

  return Array.from(unknownActions);
}
